.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  font-size: var(--fs-sm);
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
  transition: transform 60ms var(--ease-out), background var(--motion-fast) var(--ease-out),
    border-color var(--motion-fast) var(--ease-out), color var(--motion-fast) var(--ease-out),
    box-shadow var(--motion-fast) var(--ease-out);
}

/* Snappy press: the button visibly gives under the finger right away. */
.btn:active:not(:disabled) {
  transform: scale(0.95);
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.sm {
  min-height: var(--control-height-sm);
  padding: 0 var(--space-3);
  font-size: var(--fs-xs);
}

.md {
  min-height: 42px;
  padding: 0 var(--space-5);
  font-size: var(--fs-sm);
}

/* Flat Netflix red; white label (4.8:1). */
.primary {
  background: var(--color-accent);
  color: var(--color-accent-contrast);
}
@media (hover: hover) {
  .primary:hover:not(:disabled) {
    background: var(--color-accent-hover);
  }
}
.primary:active:not(:disabled) {
  background: var(--color-accent-press);
}

.secondary {
  background: rgba(255, 255, 255, 0.12);
  color: var(--color-text);
}
@media (hover: hover) {
  .secondary:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.2);
  }
}
.secondary:active:not(:disabled) {
  background: rgba(255, 255, 255, 0.28);
}

.ghost {
  background: transparent;
  color: var(--color-text-muted);
}
@media (hover: hover) {
  .ghost:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    color: var(--color-text);
  }
}

.danger {
  background: var(--color-error-bg);
  color: var(--color-error);
}
@media (hover: hover) {
  .danger:hover:not(:disabled) {
    background: var(--color-error);
    color: var(--color-bg);
  }
}

.loading {
  cursor: progress;
}

.spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: sr-spin 0.6s linear infinite;
}

.label {
  display: inline-flex;
  align-items: center;
}

@media (pointer: coarse) {
  .sm {
    min-height: 36px;
    padding: 0 var(--space-4);
  }
  .md {
    min-height: 46px;
  }
}
